import React from 'react';
import { SocialIcon } from 'react-social-icons'
import { kilomega } from 'kilomega';

import {  Avatar, Badge, TextField, Table, TableBody, TableCell, TableRow  } from '@material-ui/core';

import * as XLayout from '@pitaman71/react-explicit-layout';
import { Clients, Streams, Values } from '@pitaman71/omniglot-live-data';
import { Domains } from '@pitaman71/omniglot-live-domains';

import { Propose } from '..';

type Item = Partial<Values.Parseable<void>> & Domains.SocialMedia._Account;

function _Avatar(props: {
    handle: string,
    service: Domains.SocialMedia.ServiceNames
}) {
    const [ count, setCount ] = React.useState<undefined|number>(undefined);
    const words = props.service.split('.');
    const network = words[words.length - 1];
    React.useEffect(() => {
        if(props.service === Domains.SocialMedia.ServiceNames.FACEBOOK) {
            fetch(`http://graph.facebook.com/${props.handle}`)
            .then(response => response.json())
            .then(asJSON => {
                try {
                    setCount(Number.parseInt(asJSON.likes));
                } catch(err:any) {
                    console.error(err);
                }
            })
        }
    }, [ props.service, network ])
    return (
        <Badge badgeContent={count === undefined ? undefined : kilomega(count)} anchorOrigin={{ vertical: 'bottom', horizontal: 'right'}}>
            <Avatar><SocialIcon network={network}/></Avatar>
        </Badge>
    );
}
export function AsAvatars(props: {
    values?: Set<Item>,
    client?: Clients.SetClient<Item>,
    serviceNames: Domains.SocialMedia.ServiceNames[],
    zeroPlaceholder?: () => JSX.Element
}) {    
    const items: JSX.Element[] = [];
    Array.from(props.values || []).forEach(item => {
        if(!item.handle || !item.service?.standard) return <React.Fragment></React.Fragment>;
        items.push(<_Avatar handle={item.handle} service={item.service.standard}/>);
    })
    if(items.length === 0 && props.zeroPlaceholder) {
        return props.zeroPlaceholder();
    }
    return (
        <XLayout.Stack.East>{items}</XLayout.Stack.East>
    );
}

export function AsTable(props: {
    active?: boolean,
    values?: Set<Item>,
    client?: Clients.SetClient<Item>
    serviceNames: Domains.SocialMedia.ServiceNames[],
    autoFocus?: boolean,
    prefix?: string,
    style?: React.CSSProperties,
    on?: {
        enter?: () => void
    }
}) {    
    const asString = Domains.SocialMedia.AccountDomain.asString();
    const serviceNames = props.serviceNames || Array.from(Domains.SocialMedia.ServiceDomain.asEnumeration(100).forward()).map(serviceName => serviceName.standard);
    return (
        <Table>
            <TableBody>
                {
                    serviceNames.map(serviceName => {
                        const words = serviceName.split('.');
                        const network = words[words.length - 1];
                        const values = Array.from(props.values || []).filter(item => item.service?.standard === serviceName);
                        const handle = values.length > 0 ? values[0].handle : undefined;
                        return (
                            <TableRow>
                                <TableCell><SocialIcon network={network}/></TableCell>
                                <TableCell>
                                    <TextField
                                        id={!props.prefix ? undefined : `${props.prefix}-${network}`}
                                        value={handle} 
                                        placeholder={`${network} handle`}
                                        onChange={props.active === false || !props.client ? undefined : (event:any) => {
                                            const keep = new Set([event.target.value || ""]);
                                            const values_: Item[] = [];
                                            Array.from(props.values || []).forEach(item => {
                                                if(item.service?.standard === undefined) {
                                                    // skip it
                                                } else if(item.service?.standard !== serviceName) {
                                                    values_.push(item);
                                                } else if(keep.has(item.handle)) {
                                                    values_.push(item);
                                                    keep.delete(item.handle);
                                                } else {}
                                            });
                                            Array.from(keep).forEach(handle => {
                                                if(keep.has(handle)) {
                                                    values_.push(asString.from(`${serviceName}:${handle}`));
                                                }
                                            });
                                            if(values_.length === 0) 
                                                props.client?.clear();
                                            else
                                                props.client?.assign(new Set(values_));
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </Table>
    );
}
